module.exports = __webpack_public_path__ + "static/media/connected-apps-icon.aa6158b5.svg";